export default "__VITE_ASSET__DO5OPV0b__"